import React, { useState } from 'react';
import Select, { components } from 'react-select';
import { DateRangeSet } from './DatePicker';

const { ValueContainer, Placeholder } = components;

const CustomValueContainer = ({ children, ...props }) => {
    return (
        <ValueContainer {...props}>
            <Placeholder {...props} isFocused={props.isFocused}>
                {props.selectProps.placeholder}
            </Placeholder>
            {React.Children.map(children, child =>
                child && child.type !== Placeholder ? child : null
            )}
        </ValueContainer>
    );
};

// Status options
const overallStatusOptions = [
    { value: '1', label: 'New' },
    { value: '2', label: 'Pending' },
    { value: '3', label: 'Completed' }
];

const bankMatchStatusOptions = [
    { value: '0', label: 'NO action' },
    { value: '1', label: 'Partial Match' },
    { value: '2', label: 'System Matched' },
    { value: '3', label: 'Manual Match' },
    { value: '4', label: 'Not Matched' }
];

const loanAssignedStatusOptions = [
    { value: '0', label: 'NO action' },
    { value: '1', label: 'Partial Match' },
    { value: '2', label: 'System Matched' },
    { value: '3', label: 'Manual Match' },
    { value: '4', label: 'Not Matched' }
];

const ReconListFilter = ({ onApplyFilters }) => {
    const [searchText, setSearchText] = useState('');
    const [dealerId, setDealerId] = useState('');
    const [dealerName, setDealerName] = useState('');
    const [dateRange, setDateRange] = useState({ start_date: '', end_date: '' });
    const [overallStatus, setOverallStatus] = useState(null);
    const [bankMatchStatus, setBankMatchStatus] = useState(null);
    const [loanAssignedStatus, setLoanAssignedStatus] = useState(null);

    const handleSearch = () => {
        const filters = {};

        if (dealerId) filters.dealer_id = parseInt(dealerId);
        if (dealerName) filters.dealer_name = dealerName;
        if (searchText) filters.search_text = searchText;
        if (dateRange.start_date) filters.start_date = dateRange.start_date;
        if (dateRange.end_date) filters.end_date = dateRange.end_date;
        if (overallStatus) filters.overall_status = overallStatus.value;
        if (bankMatchStatus) filters.bank_match_status = bankMatchStatus.value;
        if (loanAssignedStatus) filters.loan_assigned_status = loanAssignedStatus.value;

        onApplyFilters(filters);
    };

    const handleReset = () => {
        setSearchText('');
        setDealerId('');
        setDealerName('');
        setDateRange({ start_date: '', end_date: '' });
        setOverallStatus(null);
        setBankMatchStatus(null);
        setLoanAssignedStatus(null);
        onApplyFilters({});
    };

    const handleDateRangeChange = (range) => {
        setDateRange(range);
    };

    return (
        <React.Fragment>
            <div className="lead-list-filter">
                <fieldset className="search-bx">
                    <div className="material">
                        <input
                            id="search"
                            type="text"
                            placeholder="Search by Dealer Name or ID"
                            name="search"
                            className="form-input"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                        />
                        <i className="ic-search"></i>
                    </div>
                </fieldset>

                <fieldset className="">
                    <div className="material">
                        <input
                            id="dealerId"
                            type="number"
                            placeholder="Dealer ID"
                            name="dealerId"
                            className="form-input"
                            value={dealerId}
                            onChange={(e) => setDealerId(e.target.value)}
                        />
                    </div>
                </fieldset>

                <fieldset className="">
                    <div className="material">
                        <DateRangeSet onChange={handleDateRangeChange} value={dateRange} />
                    </div>
                </fieldset>

                <fieldset className="single-select">
                    <div className="material">
                        <Select
                            components={{ ValueContainer: CustomValueContainer }}
                            options={overallStatusOptions}
                            placeholder="Overall Status"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={overallStatus}
                            onChange={setOverallStatus}
                            isClearable
                        />
                    </div>
                </fieldset>

                <fieldset className="single-select">
                    <div className="material">
                        <Select
                            components={{ ValueContainer: CustomValueContainer }}
                            options={bankMatchStatusOptions}
                            placeholder="Bank Match Status"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={bankMatchStatus}
                            onChange={setBankMatchStatus}
                            isClearable
                        />
                    </div>
                </fieldset>

                <fieldset className="single-select">
                    <div className="material">
                        <Select
                            components={{ ValueContainer: CustomValueContainer }}
                            options={loanAssignedStatusOptions}
                            placeholder="Loan Assigned Status"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={loanAssignedStatus}
                            onChange={setLoanAssignedStatus}
                            isClearable
                        />
                    </div>
                </fieldset>

                <div className="btn-submit-reset">
                    <button className="btn-primary" onClick={handleSearch}>Search</button>
                    <button className="btn-reset" onClick={handleReset}>Reset</button>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ReconListFilter;